import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
  root: {
    minHeight: '100vh',
    backgroundColor: '#F7F7F7',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: theme.spacing(4),
    paddingTop: theme.spacing(8),
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(3),
      paddingTop: theme.spacing(6),
    },
  },
  logoContainer: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: theme.spacing(4),
    [theme.breakpoints.down('sm')]: {
      marginBottom: theme.spacing(3),
      flexWrap: 'wrap',
      justifyContent: 'center',
    },
  },
  logo: {
    height: 64,
    width: 'auto',
    [theme.breakpoints.down('sm')]: {
      height: 52,
    },
  },
  taglineDivider: {
    width: 1,
    height: 40,
    backgroundColor: '#D8D8D8',
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      height: 32,
      marginLeft: theme.spacing(1.5),
      marginRight: theme.spacing(1.5),
    },
  },
  tagline: {
    fontFamily: '"Frank Ruhl Libre", serif',
    fontSize: 20,
    color: '#00234B',
    fontWeight: 800,
    [theme.breakpoints.down('sm')]: {
      fontSize: 16,
    },
  },
  card: {
    maxWidth: 440,
    width: '100%',
    backgroundColor: '#FFFFFF',
    borderRadius: 8,
    padding: theme.spacing(5),
    boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.08)',
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(4),
      maxWidth: 400,
    },
  },
  loadingContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: theme.spacing(4),
  },
  loadingText: {
    marginTop: theme.spacing(2),
    color: '#555555',
    fontSize: 14,
  },
  successContainer: {
    textAlign: 'center',
  },
  successIcon: {
    color: '#4CAF50',
    fontSize: 48,
    marginBottom: theme.spacing(2),
  },
  successTitle: {
    fontWeight: 700,
    fontSize: 24,
    color: '#00234B',
    marginBottom: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      fontSize: 22,
    },
  },
  successDescription: {
    color: '#555555',
    fontSize: 14,
    lineHeight: 1.6,
  },
  errorContainer: {
    textAlign: 'center',
  },
  errorIcon: {
    color: '#f44336',
    fontSize: 48,
    marginBottom: theme.spacing(2),
  },
  errorTitle: {
    fontWeight: 700,
    fontSize: 24,
    color: '#00234B',
    marginBottom: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      fontSize: 22,
    },
  },
  errorDescription: {
    color: '#555555',
    fontSize: 14,
    lineHeight: 1.6,
    marginBottom: theme.spacing(3),
  },
  actionButton: {
    backgroundColor: '#00234B',
    color: '#FFFFFF',
    fontWeight: 600,
    fontSize: 14,
    textTransform: 'uppercase',
    letterSpacing: 1,
    padding: theme.spacing(1.5),
    borderRadius: 4,
    '&:hover': {
      backgroundColor: '#001834',
    },
  },
  helpLink: {
    textAlign: 'center',
    marginTop: theme.spacing(3),
    fontSize: 14,
    color: '#555555',
  },
  supportLink: {
    color: '#3268A7',
    fontWeight: 600,
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  footer: {
    marginTop: 'auto',
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(2),
    color: '#9E9E9E',
    fontSize: 12,
  },
}))

export default useStyles
